import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { URL_SERVICIOS_INTERNA } from '../../config/config';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class PerfilService {

  constructor(public http: HttpClient, public router: Router) { }

  getObtenerGrillaxTermino(termino: string): Observable<any>  {
    const url = URL_SERVICIOS_INTERNA + 'api/Perfil/ObtenerGrillaxTermino';

    return this.http.get( url + '?termino=' + termino)
      .pipe(map( (resp: any) => resp));
  }
}
